<script setup lang="ts">
import { CtToast } from '@camelot/components'
import { storeToRefs } from 'pinia'
import { usePrebookingCreationStore } from '~/stores/prebooking-creation'

const prebookingCreationStore = usePrebookingCreationStore()
const { errorPrebookingCreation } = storeToRefs(prebookingCreationStore)
const route = useRoute()

const ERROR_TOAST_TIMEOUT = 5000

watch(errorPrebookingCreation, (errorText) => {
  if (errorText) {
    setTimeout(() => prebookingCreationStore.clearErrorToast(), ERROR_TOAST_TIMEOUT)
  }
})

watch(() => route.path, () => prebookingCreationStore.clearErrorToast())

onMounted(() => {
  document.body.classList.add('webview-layout')
})
</script>

<template>
  <div class="min-h-screen container" data-layout="webview">
    <CtToast
      v-if="errorPrebookingCreation"
      variant="error"
      :text="errorPrebookingCreation ?? 'Oops 🤷🏻'"
    />
    <NuxtPage class="" />
  </div>
</template>

<style scoped lang="scss">
:deep(.ct-toast) {
  position: relative;
  font-size: 1em;
}
</style>
